module.exports = __webpack_public_path__ + "static/media/penHolder.0598e40a.jpg";